
import { Component, Prop, Vue, } from 'vue-property-decorator';
import { getAddressLines, } from '~/utils/addressFormattingMethods';
import { AddressData, isAddressData, } from '~/utils/models';

@Component
export default class PropertyAddress extends Vue {
	@Prop({
		type: Object,
		required: true,
		validator(value: unknown) {
			return isAddressData(value);
		},
	})
	address!: AddressData;

	get lines() {
		return getAddressLines(this.address);
	}
}
